import { yupResolver } from '@hookform/resolvers/yup';
import LoadingButton from '@mui/lab/LoadingButton';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import FormProvider, { RHFAutocomplete, RHFTextField, RHFPhoneInput } from 'src/components/hook-form';
import { useSnackbar } from 'src/components/snackbar';
import axios, { endpoints, simpleHeader } from 'src/utils/axios';
import * as Yup from 'yup';

import Iconify from 'src/components/iconify';
import { getRequest, postRequest } from 'src/services';
import { handleErrorMessages } from './feching';

const CustomersCreate = ({
  open,
  onClose,
  currentItem,
  reload,
  countries,
}) => {

  const theme = useTheme();
  const { enqueueSnackbar } = useSnackbar();


  const USA = countries?.find(country => country.name === "United States");

  const [isChecked, setIsChecked] = useState(false);
  const [companyName, setCompanyName] = useState('');
  const [states, setStates] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);

  const NewUserSchema = Yup.object().shape({
    first_name: Yup.string().required('First Name is required'),
    last_name: Yup.string().required('Last Name is required'),
    company_name: Yup.string().required('Company Name is required'),
    email: Yup.string().matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Please enter your email.').required('Please enter your email corretly.'),
  });

  const defaultValues = useMemo(
    () => ({
      first_name: currentItem?.first_name || '',
      last_name: currentItem?.last_name || '',
      company_name: companyName || currentItem?.company_name || '',
      title_or_designation: currentItem?.title_or_designation || '',
      email: currentItem?.email || '',
      phoneNumber: currentItem?.phone || '',
      fax: currentItem?.fax || '',
      address1: currentItem?.address || '',
      address2: currentItem?.address2 || '',
      suite: currentItem?.suite || '',
      country_id: currentItem?.country?.id || USA?.id || null,
      city: currentItem?.city || '',
      zip: currentItem?.zip || '',
      ai_business_type: currentItem?.ai_business_type || '',
      ai_tin: currentItem?.ai_tin || '',
      ai_client_category: currentItem?.ai_client_category || '',
      ai_preferred_payment_term: currentItem?.ai_preferred_payment_term || '',
      ai_payment_schedule_frequency: currentItem?.ai_payment_schedule_frequency || '',
      ai_customer_risk_level: currentItem?.ai_customer_risk_level || '',
      ai_account_manager: currentItem?.ai_account_manager || '',
      ai_notes: currentItem?.ai_notes || '',
      ai_industry: currentItem?.ai_industry || '',

    }),
    [currentItem, USA, companyName]
  );

  const methods = useForm({
    resolver: yupResolver(NewUserSchema),
    defaultValues,
  });


  const {
    reset,
    setValue,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  useEffect(() => {
    getProfile();
  }, []);

  useEffect(() => {
    if (open) {
      reset({ ...defaultValues, company_name: companyName });
    }
  }, [reset, defaultValues, open, companyName]);



  useEffect(() => {
    const fetchData = async () => {
      if (open) {
        try {
          if (currentItem.id) {
            setSelectedCountry(currentItem?.country);
            setValue('country_id', currentItem?.country?.id);
            setSelectedState(currentItem?.state);
            setValue('state_id', currentItem?.state?.id);
          } else {
            if (!USA) {
              console.error("USA not found in countries list");
              return;
            }
            setSelectedCountry(USA);
            setValue('country_id', USA.id);

            const USAStates = await fetchStates(USA.id);
            const NY = USAStates?.find(state => state.name === "New York");
            setSelectedState(NY);
            setValue('state_id', NY?.id);
          }
        } catch (error) {
          console.error("Error fetching states:", error);
        }
      }
    };
    fetchData();
  }, [open, currentItem, USA]);

  useEffect(() => {
    if (open) {
      reset(defaultValues);
      setIsChecked(false)
    }
  }, [reset, defaultValues, open]);

  const getProfile = async () => {
    try {
      const data = await getRequest(endpoints.profile_info);
      setCompanyName(data.company_name || '');
    } catch (error) {
      console.error('Error fetching profile: ', error);
    }
  };

  const fetchStates = async (countryId) => {
    try {
      const response = await axios.get(
        endpoints.accounting.customers.get_states(countryId),
        {
          headers: simpleHeader,
        }
      );
      setStates(response.data || []);
      return response.data
    } catch (error) {
      console.error('Error fetching states:', error);
      enqueueSnackbar('Failed to fetch states', { variant: 'error' });
      setStates([]);
    }
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
    if (!currentItem.id) {
      setValue('ai_business_type', '');
      setValue('ai_tin', '');
      setValue('ai_client_category', '');
      setValue('ai_preferred_payment_term', '');
      setValue('ai_payment_schedule_frequency', '');
      setValue('ai_customer_risk_level', '');
      setValue('ai_account_manager', '');
      setValue('ai_notes', '');
      setValue('ai_industry', '');
    }  };

  const handleCountryChange = async (event, newCountry) => {
    setSelectedCountry(newCountry);
    setValue('country_id', newCountry?.id);
    setValue('state_id', null);
    setStates([]);
    setSelectedState(null)
    if (newCountry?.id) {
      await fetchStates(newCountry.id);
    }
  };
  const handleStateChange = async (event, newState) => {
    setSelectedState(newState)
    setValue('state_id', newState?.id)
  };

  const onSubmit = handleSubmit(async (data) => {
    console.log(selectedState)
    console.log(data)
    try {
      const formData = new FormData();
      formData.append('first_name', data.first_name);
      formData.append('last_name', data.last_name);
      formData.append('company_name', data.company_name);
      formData.append('title_or_designation', data.title_or_designation);
      formData.append('email', data.email);
      formData.append('phone', data.phoneNumber);
      formData.append('fax', data.fax || '');
      formData.append('address1', data.address1 || '');
      formData.append('address2', data.address2 || '');
      formData.append('suite', data.suite || '');
      formData.append('country_id', data.country_id || '');
      formData.append('state_id', data.state_id || '');
      formData.append('city', data.city || '');
      formData.append('zip', data.zip || '');
      formData.append('ai_business_type', data.ai_business_type || '');
      formData.append('ai_tin', data.ai_tin || '');
      formData.append('ai_client_category', data.ai_client_category || '');
      formData.append('ai_preferred_payment_term', data.ai_preferred_payment_term || '');
      formData.append('ai_payment_schedule_frequency', data.ai_payment_schedule_frequency || '');
      formData.append('ai_customer_risk_level', data.ai_customer_risk_level || '');
      formData.append('ai_account_manager', data.ai_account_manager || '');
      formData.append('ai_industry', data.ai_industry || '');
      formData.append('ai_notes', data.ai_notes || '');

      const result = await postRequest(
        currentItem?.id
          ? `${endpoints.accounting.customers.post_list}/${currentItem.id}?_method=PUT`
          : endpoints.accounting.customers.post_list,
        formData,
        true
      );

      if (result.metadata?.success) {
        reload();
        reset();
        onClose();
        enqueueSnackbar(currentItem?.id ? 'Customer Updated successfully' : 'Customer created successfully', { variant: 'success' });
      } else {
        handleErrorMessages(result.message);
      }
    } catch (err) {
      enqueueSnackbar('Submission failed', { variant: 'error' });
      console.error('Error in catch:', err);
    }
  });

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          onClose();
        }
      }}
      fullWidth
      maxWidth="md"
      sx={{
        borderRadius: 'none',
        padding: '60px',
        fontSize: '13px',
        fontFamily: 'arial',
      }}
      transitionDuration={{
        enter: theme.transitions.duration.shortest,
        exit: theme.transitions.duration.shortest - 80,
      }}
    >
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            boxSizing: 'content-box',
          }}
        >
          <span
            className="cardColor"
            style={{
              padding: '7px',
              marginLeft: '-25px',
              color: 'white',
              fontWeight: '700',
            }}
          >
            &nbsp;&nbsp; {currentItem.id ? "Update Customers" : 'Create Customers'} &nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          <IconButton onClick={handleClose}>
            <Iconify icon="mdi:close" />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ borderRadius: '1px' }}>
          <Box
            mt={2}
            rowGap={2}
            columnGap={2}
            display="grid"
            gridTemplateColumns={{
              xs: 'repeat(1, 1fr)',
              sm: 'repeat(2, 1fr)',
            }}
          >
            <RHFTextField
              name="first_name" label={`First Name*`} />
            <RHFTextField name="last_name" label="Last Name*" />
            <RHFTextField name="company_name" label="Company Name*" />
            <RHFTextField name="email" label="Email*" />
            <RHFTextField name="title_or_designation" label="Title/Designation" />
            <RHFPhoneInput name="phoneNumber" label="Phone Number" />
            <RHFTextField name="fax" label="Fax" />
            <RHFTextField name="address1" label="Address Line 1" />
            <RHFTextField name="address2" label="Address Line 2" />
            <RHFTextField name="suite" label="Suite" />
            <RHFAutocomplete
              name="country_id"
              label="Country"

              options={countries}
              getOptionLabel={(option) => option?.name || ''}
              isOptionEqualToValue={(option, value) => option.id === value?.id}
              renderOption={(props, option) => (
                <li {...props} key={option.id || ''}>
                  {option.name}
                </li>
              )}
              onChange={handleCountryChange}
              value={selectedCountry}
            />
            <RHFAutocomplete
              name="state_id"
              label="State"
              options={states}
              value={selectedState}
              onChange={handleStateChange}
              getOptionLabel={(option) => option?.name || ''}
              isOptionEqualToValue={(option, value) => option.id === value?.id}
              renderOption={(props, option) => (
                <li {...props} key={option.id || ''}>
                  {option?.name}
                </li>
              )}
            />

            <RHFTextField name="city" label="City" />
            <RHFTextField name="zip" label="Zip Code" />
          </Box>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              marginTop: '35px',
              marginLeft: '25px',
            }}
          >
            <span
              style={{
                fontSize: '16px',
                fontWeight: 'bold',
              }}
            >
              Additional Information
            </span>
            <input
              type="checkbox"
              style={{ width: '16px', height: '16px' }}
              onChange={handleCheckboxChange}
              checked={isChecked}
            />
          </div>

          {isChecked && (
            <>
              <Box
                mt={2}
                rowGap={1}
                columnGap={2}
                display="grid"
                gridTemplateColumns={{
                  xs: 'repeat(1, 1fr)',
                  sm: 'repeat(2, 1fr)',
                }}
              >
                <RHFAutocomplete
                  name="ai_business_type"
                  label="Business Types"
                  options={[
                    'Sole Proprietorship',
                    'Partnership',
                    'Limited Liability Company (LLC)',
                    'Corporation (C-Corp)',
                    'S Corporation (S-Corp)',
                    'Nonprofit Organization (501(c))',
                    'Government Entity',
                    'Trust & Estates'
                  ]} getOptionLabel={(option) => option}
                  isOptionEqualToValue={(option, value) => option === value}
                  renderOption={(props, option) => (
                    <li {...props} key={option}>
                      {option}
                    </li>
                  )}
                />
                <RHFTextField
                  name="ai_tin"
                  label="Tax Identification Number (Tin / EIN)"
                />
                <RHFAutocomplete
                  name="ai_client_category"
                  label="Client Category"
                  options={[
                    'Corporate Clients',
                    'Small & Medium Enterprises (SMEs)',
                    'Individual Clients',
                    'Government Clients',
                    'Nonprofit Clients',
                    'Vendors & Suppliers',
                    'Subcontractors',
                    'Investors & Shareholders',
                    'International Clients',
                    'Wholesale Clients',
                    'Retail Clients'
                  ]} getOptionLabel={(option) => option}
                  isOptionEqualToValue={(option, value) => option === value}
                  renderOption={(props, option) => (
                    <li {...props} key={option}>
                      {option}
                    </li>
                  )}
                />
                <RHFAutocomplete
                  name="ai_industry"
                  label="Industry"
                  options={[
                    'Construction Company',
                    'Retail Business',
                    'Manufacturing Firm',
                    'Service-Based Business',
                    'Healthcare Organization',
                    'Financial Institution',
                    'Technology Firm',
                    'Real Estate Business',
                    'Hospitality & Tourism'
                  ]}
                  getOptionLabel={(option) => option}
                  isOptionEqualToValue={(option, value) => option === value}
                  renderOption={(props, option) => (
                    <li {...props} key={option}>
                      {option}
                    </li>
                  )}
                />
                <RHFAutocomplete
                  name="ai_preferred_payment_term"
                  label="Preferred Payment Term"
                  options={['Net 15 Days', 'Net 30 Days', 'Net 60 Days']}
                  getOptionLabel={(option) => option}
                  isOptionEqualToValue={(option, value) => option === value}
                  renderOption={(props, option) => (
                    <li {...props} key={option}>
                      {option}
                    </li>
                  )}
                />
                <RHFAutocomplete
                  name="ai_payment_schedule_frequency"
                  label="Preferred Schedule Frequency"
                  options={['Weekly', 'Monthly', 'Quaterly', 'Yearly']}
                  getOptionLabel={(option) => option}
                  isOptionEqualToValue={(option, value) => option === value}
                  renderOption={(props, option) => (
                    <li {...props} key={option}>
                      {option}
                    </li>
                  )}
                />
                <RHFAutocomplete
                  name="ai_customer_risk_level"
                  label="Customer Risk Level"
                  options={['High', 'Medium', 'Low']}
                  getOptionLabel={(option) => option}
                  isOptionEqualToValue={(option, value) => option === value}
                  renderOption={(props, option) => (
                    <li {...props} key={option}>
                      {option}
                    </li>
                  )}
                />
                <RHFTextField name="ai_account_manager" label="Account Manager" />
              </Box>

              <Box style={{ marginTop: '10px' }}>
                <RHFTextField
                  name="ai_notes"
                  label="Notes/Remarks"
                  multiline
                  rows={4}
                />
              </Box>
            </>
          )}
        </DialogContent>

        <DialogActions>
          <Button variant="outlined" color="inherit" onClick={handleClose}>
            Close
          </Button>
          <LoadingButton
            type="submit"
            variant="contained"
            className="dark-button"
            loading={isSubmitting}
          >
            {currentItem.id ? "Update" : 'Submit'}
          </LoadingButton>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
};
export default CustomersCreate;